<div class="grid-container margin-top">
  <div class="grid-x" [formGroup]="form">
    <div class="cell small-6 medium-3 large-3 text-align-right padding-right">
      From Date:
    </div>
    <div class="cell small-6 medium-3 large-3">
      <common-date-picker [id]="'fromDate'" [formGroup]="form?.get('fromDate')" [futureDateLimit]="futureDateLimit" (dateUpdated)="fromDateChange($event)"></common-date-picker>
    </div>
    <div class="cell small-6 medium-3 large-3 text-align-right padding-right">
      To Date:
    </div>
    <div class="cell small-6 medium-3 large-3">
      <common-date-picker [id]="'fromDate'" [formGroup]="form?.get('toDate')" [pastDateLimit]="pastDateLimit" [daysFuture]="0" (dateUpdated)="toDateChange($event)"></common-date-picker>
    </div>
    <div class="cell small-6 medium-3 large-3 text-align-right padding-right">
      Message Text:
    </div>
    <div class="cell small-6 medium-3 large-3">
      <input type="text" formControlName="messageText" placeholder="Partial phrase text will match" />
    </div>
    <div class="cell small-6 medium-3 large-3 text-align-right padding-right">
      Exception Text:
    </div>
    <div class="cell small-6 medium-3 large-3">
      <input type="text" formControlName="exceptionText" placeholder="Partial phrase text will match" />
    </div>
    <div class="cell small-6 medium-3 large-3 text-align-right padding-right">
      Event Level:
    </div>
    <div class=" cell-small-6 medium-3 large-3">
      <select formControlName="eventLevel">
        @for (opt of levelOptions; track opt) {
          <option [value]="opt.id">{{opt.text}}</option>
        }
      </select>
    </div>
  </div>
</div>
<div class="grid-container margin-top extra-wide">
  <div class="grid-x">
    <div class="cell large-12 medium-12 small-12">
      <ag-grid-angular class="data-grid  full-page" [gridOptions]="gridOptions" [rowData]="data" aria-label="Application Log"></ag-grid-angular>
    </div>
  </div>
</div>